import { useCallback, useRef, useState } from 'react';
import { copyToClipboard } from '../utils/clipboard';

/**
 * Hook para copiar texto com feedback transiente.
 * `copied` fica true por `resetMs` ms após um copy bem-sucedido.
 */
export function useClipboard(resetMs = 2000) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const copy = useCallback(async (text: string) => {
    const ok = await copyToClipboard(text);
    if (ok) {
      setCopied(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), resetMs);
    }
    return ok;
  }, [resetMs]);

  return { copy, copied };
}
